// extracted by mini-css-extract-plugin
module.exports = {"header":"SectionEditorHeader_header_LS1M1","spinAround":"SectionEditorHeader_spinAround_3lG6G"};